import {z} from 'zod';

// GET /3.0/service/users/me/external-services
export const LineSchema = z.object({
  isAssociated: z.boolean(),
  isEnabled: z.boolean(),
});

export const ExternalServicesResponse = z.object({
  line: LineSchema,
});
export const PutLineAccountResponse = z.string();
export const PutLineAccountNonDisplayResponse = z.string();
export const DeleteLineAccountResponse = z.string();
export const DeleteLineAccountNonDisplayResponse = z.string();
